



export default function WebmailView() {

    return (
        <>
            View nef
        </>
    )
}